import React, {InputHTMLAttributes, useContext} from 'react'
import {Options} from '../../../types'
import AppContext from '../../lib/AppContext'
import {SetOptionAction} from '../../types'
import ErrorText from './ErrorText'

export default ({error, label, ...attrs}: InputHTMLAttributes<any> & {
    error?: string | null
    id: keyof Options
    label: string
}) => {
    const {dispatch, state: {options}} = useContext(AppContext)
    const checked = Boolean(options[attrs.id])

    return <>
        <label htmlFor={attrs.id}>
            {label}
        </label>

        <input
            {...attrs}
            checked={checked}
            onChange={e => {
                dispatch({
                    key: attrs.id,
                    value: e.currentTarget.checked,
                    type: 'SET_OPTION',
                } as SetOptionAction<typeof attrs.id>)
            }}
            type='checkbox'
            value='1'
        />

        <ErrorText error={error}/>
    </>
}
